import { render, staticRenderFns } from "./floor-4-Item.vue?vue&type=template&id=7cc0520a&scoped=true&"
import script from "./floor-4-Item.vue?vue&type=script&lang=js&"
export * from "./floor-4-Item.vue?vue&type=script&lang=js&"
import style0 from "./floor-4-Item.vue?vue&type=style&index=0&id=7cc0520a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0520a",
  null
  
)

component.options.__file = "floor-4-Item.vue"
export default component.exports